import Card from 'app/frontend/base/components/Card'
import CharacterRoleIcon from 'app/frontend/base/components/CharacterRoleIcon'
import { CharacterRole } from 'app/frontend/types/custom'
import { Badge } from '@/components/ui/badge'
import capitalize from 'lodash/capitalize'
import { EventActivityParticipantEntry } from './eventActivityParticipantEntry'
import EventActivitySetupParticipant from './EventActivitySetupParticipant'
import { Separator } from '@/components/ui/separator'
import { useTeamEventPlanningInfoContext } from '../context/TeamEventPlanningInfoContext'

type Props = {
  role: CharacterRole
  selectedEntries: EventActivityParticipantEntry[]
  benchedEntries: EventActivityParticipantEntry[]
  activity: wowaudit.EventActivity
  selectableStatuses: wowaudit.EventParticipantReference['status'][]
  canAdminEdit: boolean
  className?: string
  applyToAllActivities?: boolean
}

const EventActivityRoleBlock = ({
  role,
  selectedEntries,
  benchedEntries,
  activity,
  selectableStatuses,
  canAdminEdit,
  className,
  applyToAllActivities,
}: Props) => {
  const { showPlanningInfo } = useTeamEventPlanningInfoContext()

  return (
    <Card className={className}>
      <h3 className='flex items-center gap-2 justify-between border-b pb-2 mb-2'>
        <div className='flex items-center gap-3'>
          <CharacterRoleIcon role={role} size='large' />
          {capitalize(role)}
        </div>
        <Badge variant='outline' className='text-base'>
          {selectedEntries.length}
        </Badge>
      </h3>

      {selectedEntries.length === 0 && benchedEntries.length === 0 ? (
        <div className='text-sm text-muted-foreground italic'>None</div>
      ) : null}

      {selectedEntries.length > 0 ? (
        <div className='space-y-1'>
          <div className='text-sm text-muted-foreground'>Selected</div>
          <div className='flex flex-col gap-0'>
            {selectedEntries.map((entry) => (
              <EventActivitySetupParticipant
                key={entry.participant.id}
                entry={entry}
                activity={activity}
                selectableStatuses={selectableStatuses}
                canAdminEdit={canAdminEdit}
                variant='selected'
                applyToAllActivities={applyToAllActivities}
              />
            ))}
          </div>
        </div>
      ) : null}

      {selectedEntries.length > 0 &&
      benchedEntries.length > 0 &&
      !showPlanningInfo ? (
        <Separator className='mt-3 mb-2' />
      ) : (
        <div className='h-5' />
      )}

      {benchedEntries.length ? (
        <div className='space-y-1'>
          <div className='text-sm text-muted-foreground'>Benched</div>
          <div className='flex flex-col gap-0'>
            {benchedEntries.map((entry) => (
              <EventActivitySetupParticipant
                key={entry.participant.id}
                entry={entry}
                activity={activity}
                selectableStatuses={selectableStatuses}
                canAdminEdit={canAdminEdit}
                variant='benched'
                applyToAllActivities={applyToAllActivities}
              />
            ))}
          </div>
        </div>
      ) : null}
    </Card>
  )
}

export default EventActivityRoleBlock
